export const enMessages = {
    "custom": {
        "teamEfficiency": "Team Efficiency",
        "teamMembers": "Team Members",
        "dashboard": "Dashboard",
        "planning": "Planning",
        "profile": "Profile",
        "info": "Info",
        "inventory": "Inventory",
        "notifications": "Notifications",
        "help": "Help and Support",
        "language": "Language",
        "trend": "Trend",
        "volume": "Volume",
        "myTeam": "My Team",
        "allTeams": "All Teams",
        "teamCalendar": "Team Calendar",
        "saveChanges": "Save Changes",
        "cancel": "Cancel",
        "warehouse": "Coffee Warehouse",
        "startFreeTrial": "Start Free Trial",
        "buyNow": "Buy Now",
        "getSource": "Get the source code on GitHub",
        "demoInfo": "This demo application is built using the following KendoReact components and the KendoReact Meridian Theme.",
        "firstName": "First Name",
        "middleName": "Middle Name",
        "lastName": "Last Name",
        "email": "Email Address",
        "phoneNumber": "Phone Number",
        "country": "Country",
        "biography": "Short Biography",
        "public": "Include in public directory",
        "team": "Team",
        "employee": "Employee",
        "contactName": "Contact Name",
        "jobTitle": "Job Title",
        "salesRepresentative": "Sales Representative",
        "status": "Status",
        "performance": "Performance",
        "rating":"Rating",
        "engagement": "Engagement",
        "budget": "Budget",
        "contacts": "Contacts",
        "address": "Address",
        "phone": "Phone",
        "gridSearch": "Search in all columns...",
        "exportExcel": "Export to Excel",
        "exportPdf": "Export to PDF",
        "inventoryItem1Description": "Ethiopia Yirgacheffe, washed 60 kg",
        "inventoryItem2Description": "Colombia Huila, honey process 60 kg",
        "inventoryItem3Description": "Kraft valve bags, 12 oz",
        "inventoryItem4Description": "Brazil Cerrado, natural 60 kg",
        "inventoryItem5Description": "Compostable black lids, 1,000 units",
        "supplierHighlandOrigins": "Highland Origins",
        "supplierSierraVerde": "Sierra Verde",
        "supplierPacificPack": "Pacific Pack",
        "supplierFazendaDirect": "Fazenda Direct",
        "productName": "KendoReact",
        "kendokaIllustration": "Kendoka illustration",
        "githubIcon": "GitHub icon",
        "localeEnglish": "English",
        "localeFrench": "French",
        "localeSpanish": "Spanish",
        "openNavigation": "Open navigation",
        "searchWarehouse": "Search the warehouse",
        "openNotifications": "Open notifications",
        "userAvatar": "User avatar",
        "dashboardTitle": "Warehouse dashboard",
        "dashboardDescription": "Monitor fulfillment performance, team capacity, and operational commitments.",
        "dashboardLastUpdated": "Last updated: 5 minutes ago",
        "dashboardDataPeriod": "Sample period: Jan–Apr 2020",
        "performanceSummary": "Warehouse performance summary",
        "ordersShippedToday": "ORDERS SHIPPED TODAY",
        "ordersShippedDetail": "Up 8.4% vs yesterday",
        "onTimeFulfillment": "ON-TIME FULFILLMENT",
        "onTimeFulfillmentDetail": "Up 1.2 points vs target",
        "pickQueue": "PICK QUEUE",
        "pickQueueDetail": "Up 9 orders need attention",
        "lowStockAlerts": "LOW-STOCK ALERTS",
        "lowStockAlertsDetail": "Up 3 new since 08:00",
        "teamEfficiencyDescription": "Order revenue (USD) by team for the selected period.",
        "teamMembersDescription": "Team capacity, engagement, and operating budget.",
        "teamTiger": "Tiger Team",
        "teamLemon": "Lemon Team",
        "teamOrganic": "Organic Team",
        "teamOcean": "Ocean Team",
        "schedulerTeams": "Teams",
        "planningTitle": "Team planning",
        "planningDescription": "Assign sales representatives to scheduled order activity.",
        "planningWorkWeek": "Work week: Apr 27 - May 3",
        "planningDataPeriod": "Sample week: Apr 27–May 3, 2020",
        "teamCalendarDescription": "Select team members to include in the shared schedule.",
        "includedInSchedule": "included in schedule",
        "excludedFromSchedule": "excluded from schedule",
        "profileTitle": "Profile settings",
        "profileDescription": "Manage your contact details and workspace directory preferences.",
        "emailPlaceholder": "e.g.: peter@gmail.com",
        "inventoryTitle": "Inventory management",
        "inventoryDescription": "Track coffee, packaging, and warehouse supplies across every active bin.",
        "inventoryLastUpdated": "Last updated: Aug 25, 2026",
        "inventorySummary": "Inventory summary",
        "totalSkus": "TOTAL SKUS",
        "totalSkusDetail": "Up 34 added this quarter",
        "lowStockItems": "LOW-STOCK ITEMS",
        "lowStockItemsDetail": "Up 3 need review today",
        "inventoryValue": "INVENTORY VALUE",
        "inventoryValueDetail": "Down 2.1% vs last month",
        "inventoryOverview": "Inventory overview",
        "inventoryExplanation": "Available stock equals on-hand quantity less committed orders.",
        "createPurchaseOrder": "Create purchase order",
        "searchInventory": "Search inventory",
        "searchInventoryPlaceholder": "Search SKU, supplier, or bin",
        "inventoryEmptyTitle": "No inventory matches this search",
        "inventoryEmptyDescription": "Try a different SKU, supplier, or bin, or clear the current filter.",
        "clearInventorySearch": "Clear search",
        "sku": "SKU",
        "itemDescription": "Item description",
        "onHand": "On hand",
        "reserved": "Reserved",
        "available": "Available",
        "bin": "Bin",
        "supplier": "Supplier",
        "stockStatus": "Stock status",
        "lastMovement": "Last movement",
        "outOfStock": "Out of stock",
        "lowStock": "Low stock",
        "overstock": "Overstock",
        "inStock": "In stock",
        "notificationsTitle": "Notifications",
        "notificationsDescription": "Review warehouse updates, stock exceptions, and scheduled work.",
        "notificationsUnread": "3 unread",
        "notificationsSection": "Warehouse notifications",
        "notificationDeliveryTitle": "Brazil Cerrado delivery received",
        "notificationDeliveryDetail": "42 bags were added to bin A-02-08.",
        "notificationDeliveryTime": "8 minutes ago",
        "notificationReceived": "Received",
        "notificationStockTitle": "Kraft bag stock is below threshold",
        "notificationStockDetail": "P-02-11 has no available units remaining.",
        "notificationStockTime": "26 minutes ago",
        "notificationAttention": "Attention",
        "notificationReviewTitle": "Weekly fulfillment review is due",
        "notificationReviewDetail": "Confirm the outbound plan before 16:00.",
        "notificationReviewTime": "Yesterday, 09:15",
        "notificationScheduled": "Scheduled",
        "helpTitle": "Help and support",
        "helpDescription": "Find guidance for inventory, fulfillment, and team scheduling.",
        "searchHelpTopics": "Search help topics",
        "searchHelpTopicsPlaceholder": "Search help topics",
        "helpPurchaseQuestion": "How do I create a purchase order?",
        "helpPurchaseAnswer": "From Inventory, select Create purchase order after reviewing the affected stock item and supplier.",
        "helpLowStockQuestion": "Why is an item marked low stock?",
        "helpLowStockAnswer": "Low stock indicates that available quantity has reached the reorder threshold after reservations are applied.",
        "helpScheduleQuestion": "How do I update a team schedule?",
        "helpScheduleAnswer": "Open Planning, select the team member, then create or adjust an assignment in the scheduler.",
        "notFoundTitle": "Error 404: Page not found",
        "notFoundDescription": "The warehouse workspace you requested does not exist or has been moved.",
        "goToDashboard": "Go to main dashboard",
        "masterReactUi": "Master the Art of React UI",
        "buttons": "Buttons",
        "button": "Button",
        "buttonGroup": "ButtonGroup",
        "dataQuery": "Data Query",
        "charts": "Charts",
        "chart": "Chart",
        "columnBar": "Column Bar",
        "horizontalLine": "Horizontal Line",
        "dataTools": "Data Tools",
        "pager": "Pager",
        "dateInputs": "Date Inputs",
        "dateRangePicker": "DateRangePicker",
        "dialogs": "Dialogs",
        "dialog": "Dialog",
        "drawing": "Drawing",
        "dropdowns": "Dropdowns",
        "autoComplete": "AutoComplete",
        "dropDownList": "DropDownList",
        "editor": "Editor",
        "excelExport": "Excel Export",
        "form": "Form",
        "grid": "Grid",
        "inputs": "Inputs",
        "checkbox": "Checkbox",
        "input": "Input",
        "maskedTextBox": "MaskedTextBox",
        "switch": "Switch",
        "layout": "Layout",
        "avatar": "Avatar",
        "card": "Card",
        "drawer": "Drawer",
        "scheduler": "Scheduler",
        "tooltip": "Tooltip",
        "upload": "Upload",
        "online": "Online",
        "offline": "Offline",
        "validationEmail": "You have entered an invalid email address!",
        "validationRequired": "This field is required",
        "validationPhone": "Please enter valid phone number.",
        "validationBiography": "Biography must be at least 50 characters long."
    },
    "grid":{
        "groupPanelEmpty": "Drag a column header and drop it here to group by that column",
        "pagerItemsPerPage": "items per page",
        "pagerInfo": "{0} - {1} of {2} items",
        "pagerFirstPage": "Go to the first page",
        "pagerPreviousPage": "Go to the previous page",
        "pagerNextPage": "Go to the next page",
        "pagerLastPage": "Go to the last page",
        "pagerPage": "Page",
        "pagerOf": "of",
        "filterClearButton":"Clear",
        "filterEqOperator": "Is equal to",
        "filterNotEqOperator": "Is not equal to",
        "filterIsNullOperator": "Is null",
        "filterIsNotNullOperator": "Is not null",
        "filterIsEmptyOperator": "Is empty",
        "filterIsNotEmptyOperator": "Is not empty",
        "filterStartsWithOperator": "Starts with",
        "filterContainsOperator": "Contains",
        "filterNotContainsOperator": "Does not contain",
        "filterEndsWithOperator": "Ends with",
        "filterGteOperator": "Is greater than or equal to",
        "filterGtOperator": "Is greater than",
        "filterLteOperator": "Is less than or equal to",
        "filterLtOperator":"Is less than",
        "filterIsTrue":"Is true",
        "filterIsFalse": "Is false",
        "filterBooleanAll": "(All)",
        "filterAfterOrEqualOperator": "Is after or equal to",
        "filterAfterOperator": "Is after",
        "filterBeforeOperator":"Is before",
        "filterBeforeOrEqualOperator":"Is before or equal to",
        "noRecords":"No records available."
    },
    "filter": {
        "eqOperator": "Is equal to",
        "notEqOperator": "Is not equal to",
        "isNullOperator": "Is null",
        "isNotNullOperator": "Is not null",
        "isEmptyOperator": "Is empty",
        "isNotEmptyOperator": "Is not empty",
        "startsWithOperator": "Starts with",
        "containsOperator": "Contains",
        "notContainsOperator": "Does not contain",
        "endsWithOperator": "Ends with",
        "gteOperator": "Is greater than or equal to",
        "gtOperator": "Is greater than",
        "lteOperator": "Is less than or equal to",
        "ltOperator": "Is less than",
        "isTrue": "Is true",
        "isFalse": "Is false",
        "afterOrEqualOperator": "Is after or equal to",
        "afterOperator": "Is after",
        "beforeOperator": "Is before",
        "beforeOrEqualOperator": "Is before or equal to",
        "andLogic": "And",
        "orLogic": "Or",
        "addExpression": "Add Expression",
        "addGroup": "Add Group",
        "close": "Close"
    },
    "dateinput":{
        "increment": "Increase value",
        "decrement": "Decrease value"
    },
    "calendar":{
        "today":"TODAY"
    },
    "datepicker":{
        "toggleCalendar": "Toggle calendar"
    },
    "daterangepicker": {
        "swapStartEnd": "Swap start and end values",
        "start": "Start",
        "end": "End",
        "separator": " "
    },
    "datetimepicker": {
        "date": "Date",
        "time": "Time",
        "toggleDateTimeSelector": "Toggle date-time selector",
        "cancel": "Cancel",
        "set": "Set"
    },
    "editor": {
        "bold": "Bold",
        "italic": "Italic",
        "underline": "Underline",
        "strikethrough": "Strikethrough",
        "subscript": "Subscript",
        "superscript": "Superscript",
        "unlink": "Remove hyperlink",
        "undo": "Undo",
        "redo": "Redo",
        "fontSize": "Font Size",
        "fontName": "Font Name",
        "format": "Format",
        "alignLeft": "Align text left",
        "alignRight": "Align text right",
        "alignCenter": "Center text",
        "alignJustify": "Justify",
        "indent": "Indent",
        "outdent": "Outdent",
        "orderedList": "Insert ordered list",
        "bulletList": "Insert unordered list",
        "createTable": "Create a table",
        "insertTableHint": "Create a {0} x {1} table",
        "addRowBefore": "Add row above",
        "addRowAfter": "Add row below",
        "addColumnBefore": "Add column on the left",
        "addColumnAfter": "Add column on the right",
        "deleteRow": "Delete row",
        "deleteColumn": "Delete column",
        "deleteTable": "Delete table",
        "mergeCells": "Merge cells",
        "splitCell": "Split cell",
        "hyperlink": "Insert hyperlink",
        "hyperlink-dialog-title": "Insert hyperlink",
        "hyperlink-dialog-content-address": "Web address",
        "hyperlink-dialog-content-title": "Title",
        "hyperlink-dialog-content-newwindow": "Open link in new window",
        "hyperlink-dialog-cancel": "Cancel",
        "hyperlink-dialog-insert": "Insert",
        "image": "Insert image",
        "image-dialog-title": "Insert image",
        "image-address": "Web address",
        "image-title": "Title",
        "image-altText": "Alternate text",
        "image-width": "Width (px)",
        "image-height": "Height (px)",
        "image-cancel": "Cancel",
        "image-insert": "Insert",
        "viewHtml": "View HTML",
        "viewHtml-dialog-title": "View HTML",
        "viewHtml-cancel": "Cancel",
        "viewHtml-update": "Update"
    },
    "timepicker": {
        "now": "NOW",
        "selectNow": "Select Now",
        "cancel": "Cancel",
        "set": "Set",
        "toggleTimeSelector": "Toggle TimeSelector",
        "toggleClock": "Toggle Clock"
    },
    "dropdowns":{
        "nodata": "NO DATA FOUND.",
        "clear": "Clear"
    },
    "numerictextbox":{
        "increment": "Increase value",
        "decrement": "Decrease value"
    },
    "upload": {
        "cancel": "Cancel",
        "clearSelectedFiles": "Clear",
        "dropFilesHere": "Drop files here to upload",
        "headerStatusUploaded": "Done",
        "headerStatusUploading": "Uploading...",
        "invalidFileExtension": "File type not allowed.",
        "invalidFiles": "Invalid file(s). Please check file upload requirements.",
        "invalidMaxFileSize": "File size too large.",
        "invalidMinFileSize": "File size too small.",
        "remove": "Remove",
        "retry": "Retry",
        "select": "Select files...",
        "uploadSelectedFiles": "Upload",
        "total": "Total",
        "files": "files"
    },
    "sortable": {
        "noData": "No Data"
    },
    "pager": {
        "itemsPerPage": "items per page",
        "info": "{0} - {1} of {2} items",
        "firstPage": "Go to the first page",
        "previousPage": "Go to the previous page",
        "nextPage": "Go to the next page",
        "lastPage": "Go to the last page",
        "page": "Page",
        "of": "of"
    },
    "treelist": {
        "filterClearButton": "Clear",
        "filterEqOperator": "Is equal to",
        "filterNotEqOperator": "Is not equal to",
        "filterIsNullOperator": "Is null",
        "filterIsNotNullOperator": "Is not null",
        "filterIsEmptyOperator": "Is empty",
        "filterIsNotEmptyOperator": "Is not empty",
        "filterStartsWithOperator": "Starts with",
        "filterContainsOperator": "Contains",
        "filterNotContainsOperator": "Does not contain",
        "filterEndsWithOperator": "Ends with",
        "filterGteOperator": "Is greater than or equal to",
        "filterGtOperator": "Is greater than",
        "filterLteOperator": "Is less than or equal to",
        "filterLtOperator": "Is less than",
        "filterIsTrue": "Is true",
        "filterIsFalse": "Is false",
        "filterBooleanAll": "(All)",
        "filterAfterOrEqualOperator": "Is after or equal to",
        "filterAfterOperator": "Is after",
        "filterBeforeOperator": "Is before",
        "filterBeforeOrEqualOperator": "Is before or equal to",
        "noRecords": "No records available"
    },
    "scheduler": {
        "editorValidationRequired": "Field is required.",
        "editorValidationStart": "Start time must be be before End time.",
        "editorValidationEnd": "End time must be after Start time.",
        "allEvents": "All events",
        "allDay": "all day",
        "today": "Today",
        "dayViewTitle": "Day",
        "monthViewTitle": "Month",
        "weekViewTitle": "Week",
        "workWeekViewTitle": "Work Week",
        "timelineViewTitle": "Timeline",
        "agendaViewTitle": "Agenda",
        "deleteTitle": "Delete",
        "previousTitle": "Previous",
        "nextTitle": "Next",
        "showFullDay": "Show full day",
        "showWorkDay": "Show business hours",
        "editorOccurrence": "Edit current occurrence",
        "editorSeries": "Edit the series",
        "editorRecurringConfirmation": "Do you want to edit only this event occurrence or the whole series?",
        "editorRecurringDialogTitle": "Edit Recurring Item",
        "editorSave": "Save",
        "editorCancel": "Cancel",
        "editorDelete": "Delete",
        "editorTitle": "Event",
        "editorEventTitle": "Title",
        "editorEventStart": "Start",
        "editorEventStartTimeZone": "Start Time Zone",
        "editorEventEnd": "End",
        "editorEventEndTimeZone": "End Time Zone",
        "editorEventAllDay": "All Day Event",
        "editorEventDescription": "Description",
        "editorEventSeparateTimeZones": "End in different Time Zone",
        "editorEventTimeZone": "Specify Time Zone",
        "recurrenceEditorRepeat": "Repeat",
        "recurrenceEditorDailyInterval": "day(s)",
        "recurrenceEditorDailyRepeatEvery": "Repeat every",
        "recurrenceEditorWeeklyInterval": "week(s)",
        "recurrenceEditorWeeklyRepeatEvery": "Repeat every",
        "recurrenceEditorWeeklyRepeatOn": "Repeat on",
        "recurrenceEditorMonthlyDay": "Day",
        "recurrenceEditorMonthlyInterval": "month(s)",
        "recurrenceEditorMonthlyRepeatEvery": "Repeat every",
        "recurrenceEditorMonthlyRepeatOn": "Repeat on",
        "recurrenceEditorYearlyOf": "of",
        "recurrenceEditorYearlyRepeatEvery": "Repeat every",
        "recurrenceEditorYearlyRepeatOn": "Repeat on",
        "recurrenceEditorYearlyInterval": "year(s)",
        "recurrenceEditorFrequenciesDaily": "Daily",
        "recurrenceEditorFrequenciesMonthly": "Monthly",
        "recurrenceEditorFrequenciesNever": "Never",
        "recurrenceEditorFrequenciesWeekly": "Weekly",
        "recurrenceEditorFrequenciesYearly": "Yearly",
        "recurrenceEditorOffsetPositionsFirst": "First",
        "recurrenceEditorOffsetPositionsSecond": "Second",
        "recurrenceEditorOffsetPositionsThird": "Third",
        "recurrenceEditorOffsetPositionsFourth": "Fourth",
        "recurrenceEditorOffsetPositionsLast": "Last",
        "recurrenceEditorWeekdaysDay": "Day",
        "recurrenceEditorWeekdaysWeekday": "Weekday",
        "recurrenceEditorWeekdaysWeekendday": "Weekend Day",
        "recurrenceEditorEndAfter": "After",
        "recurrenceEditorEndOccurrence": "occurrence(s)",
        "recurrenceEditorEndLabel": "End",
        "recurrenceEditorEndNever": "Never",
        "recurrenceEditorEndOn": "On",
        "deleteConfirmation": "Are you sure you want to delete this event?",
        "deleteRecurringConfirmation": "Do you want to delete only this event occurrence or the whole series?",
        "deleteOccurrence": "Delete current occurrence",
        "deleteSeries": "Delete the series",
        "deleteDialogTitle": "Delete Event",
        "deleteRecurringDialogTitle": "Delete Recurring Item",
        "dateTitle": "Date",
        "timeTitle": "Time",
        "eventTitle": "Event",
        "noEvents": "no events"
    }
};